import React, { useState } from "react";
import Button from "../Button";
import { post } from "../../lib/Fetching";

export default function CaveatCopier({ sampleIds, resultCaveatIds, onCopy }) {
  if (!sampleIds || !resultCaveatIds || sampleIds.length == 0 || resultCaveatIds.length == 0) {
    return null;
  }

  const handleSubmit = () => {
    if (
      !confirm("Are you sure you want to copy the selected caveats to the selected samples?")
    ) {
      return;
    }
    post("/sample_testing/result_caveats/copy_result_caveats_to_samples", {
      sample_ids: sampleIds,
      result_caveat_ids: resultCaveatIds
    }).then(json => {
      alert("COpied!");
      onCopy();
    });
  };

  return (
    <Button onClick={handleSubmit} primary tiny title="Copy caveats to selected samples" />
  );
}
